import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { reducer as toastrReducer } from 'react-redux-toastr'

const rootReducer = combineReducers({
  router: routerReducer,
  toastr: toastrReducer,
  loader: require('./loader').default,
  apis: require('./apis').default,
  operations: require('./operations').default,
  operationResponses: require('./operationResponses').default,
  definitions: require('./definitions').default,
  configs: require('./configs').default,
  uiState: require('./uiState').default,
  plugins: require('./plugins').default,
  operationLastParameters: require('./operationLastParameters').default,
  operationLocalParameters: require('./operationLocalParameters').default
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js